import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { IOrganisation } from 'src/app/interfaces/organisation';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { IGroup } from 'src/app/interfaces/group';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { OrganisationDataSource } from 'src/modules/organisation/services/organisation-data-source';
import { PageEvent } from '@angular/material/paginator';
@Injectable()
export class OrganisationAdminApiService {
  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public getDataSource(): OrganisationDataSource {
    return new OrganisationDataSource('organisation-admin');
  }

  public getOrgs(
    userId: number,
    filter?: {},
    PageEvent?: PageEvent,
    role?: string
  ) {
    let endpoint = `${role}/organisations`;
    if (userId) {
      endpoint += `/user-id/${userId}`;
    }
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.getWithPageEventFilter(endpoint, PageEvent, filter, url);
  }

  public getFilteredOrgs(filter?: {}, role?: string) {
    let endpoint = `${role}/organisations`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.getWithoutPageEventFilter(endpoint, filter, url)
      .then((payload: { data: IOrganisation[] }) => payload)
      .catch((error) => this.Api.handleError(error));
  }

  public save(role: string, org) {
    return org.id ? this.update(role, org) : this.create(role, org);
  }

  public updateAccountCode(role: string, org) {
    
    const url = this.commonFunctionService.findApiUrl(role);
    const endpoint = `${role}/organisation/account-code`;
    
    return this.Api.post(endpoint, org, url).then(
      (result) => {
        this.Api.handleSuccess('Account code saved');
        return result;
      },
      (error) => this.Api.handleError(error)
    );
  }

  public create(role: string, org) {
    const url = this.commonFunctionService.findApiUrl(role);

    const endpoint = `${role}/organisation/create`;
    return this.Api.post(endpoint, org, url).then(
      (result) => {
        this.Api.handleSuccess('Organisation saved');
        return result;
      },
      (error) => this.Api.handleError(error)
    );
  }

  public update(role: string, org) {
    const url = this.commonFunctionService.findApiUrl(role);
    const endpoint = `${role}/organisation/${org.id}/id/${org.product_id}`;
    
    return this.Api.post(endpoint, org, url).then(
      (result) => {
        this.Api.handleSuccess('Organisation saved');
        return result;
      },
      (error) => this.Api.handleError(error)
    );
  }

  public read(organisationId: number, role?: string) {
    const endpoint = `organisation-admin/organisations/organisation-id/${organisationId}`;
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.get(endpoint, url)
      .then((Organisation: IOrganisation) => Organisation)
      .catch((error) => this.Api.handleError(error));
  }

  public delete(orgId: number, userId: number, role?: string) {
    let endpoint = `${role}/user-id/${userId}/org-id/${orgId}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.delete(endpoint, url);
  }

  public deleteGroup(groupId: number, userId: number, role?: string) {
    let endpoint = `${role}/user-id/${userId}/group-id/${groupId}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.delete(endpoint, url);
  }

  public addUserToOrganisation(options, role?: string) {
    let endpoint = `${role}/user-organisation`;
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.post(endpoint, options, url);
  }

  public downloadOrderReport(role: string, orgId: number) {
    const url = this.commonFunctionService.findApiUrl(role);
    const endpoint = `${role}/download-order-report?orgId=${orgId}`;

    return this.Api.get(endpoint, url)
      .catch((error) => this.Api.handleError(error));
  }
}
